<template>
    <div>
      <Head title="Admin" />
      <v-container class="grey lighten-5">
        <v-card>
          <v-card-title>
            Roles
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              @input="getDataFromApi()"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
           
            <v-spacer></v-spacer>
            <v-btn
            class="mx-2"
            fab
            dark
            color="primary"
            @click="addNew"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="roles"
            :options.sync="options"
            :items-per-page="itemsPerPage"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
          >
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="modifyItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              v-if="0"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
        </v-card> 

        <v-dialog v-model="dialogAdd" max-width="500px"
        >
          <v-card>
            <v-card-title>
              <span class="text-h5">Add New Role</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newrole.name"
                      label="Name"
                    ></v-text-field>
                  </v-col>
                  
                  
                  
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeAddDialog"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="saveAddDialog"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete = !dialogDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog 
          v-model="dialogEdit" 
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition">
          <v-card>
              <v-toolbar
                dark
                color="primary"
              >
                <v-btn
                  icon
                  dark
                  @click="dialogEdit = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Edit Permissions for {{editItem.name}}</v-toolbar-title>
                
              </v-toolbar>
            
              <br/><br/>
              <v-container>
                <v-row>
                  <template v-for="p in permissions">
                    <v-col
                      cols="12"
                      sm="6"
                      md="3" 
                    >
                      <v-checkbox 
                        v-model="p.value"
                        :label="p.name"
                        @change="updatePermission(p)"
                        ></v-checkbox>
                  
                    </v-col>
                  </template>
                </v-row>
              </v-container>
              
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogEdit = !dialogEdit"><v-icon>mdi-close</v-icon> Close</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'
  

  export default {
    props: {
      roleList: Array,
      permissionList: Array
    },
    components: {
      Head,
    },
    layout: Layout,
    data() {
        return {
            role: '',
            roles: [],
            permissions: [],
            list: [],
            keyword: "",
            location: "",
            category: "",
            editItem: {name:''},
            total: this.roleList ? this.roleList.length : 0,
            itemsPerPage: 20,
            loading: false,
            loadingAdd: false,
            options: {},
            search: "",
            headers: [
              { text: 'ID', value:'id'},
              { text: 'Name', value:'name'},
              { text: 'Actions', value:'actions'},

            ],
            newrole: {
              name:""
            },
            dialogAdd: false,
            dialogEdit: false,
            dialogDelete: false
        }
    },
    watch: {
      options: {
        handler () {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    created() {
      this.roles = JSON.parse(JSON.stringify(this.roleList));
      this.permissions = JSON.parse(JSON.stringify(this.permissionList));
      this.permissions.sort((a, b) => a.name.localeCompare(b.name));
    },
    methods: {
      generatePassword() {
        this.newrole.password= [...window.crypto.getRandomValues(new Uint32Array(passwordLength))]
                .map(x => passwordChars[x % passwordChars.length])
                .join('')
      },
      addNew(){
        Object.keys(this.newrole).forEach(key => {
          this.newrole[key] = "";
        });
        this.dialogAdd = true;
      },
      getDataFromApi () {
        this.loading = true
        console.log('getting request',this.options)
        var params = JSON.parse(JSON.stringify(this.options));
        params.filters = { search: this.search};

        axios.get("/admin/roles/list",{ params: params }).then((response) => {
          this.roles = response.data.list
          this.total= response.data.total;
          this.loading = false;
        });
      },
      deleteItemConfirm () {
        this.closeDelete()
      },

      closeAddDialog () {
        this.dialogAdd = false
      },

      closeDelete () {
        this.dialogDelete = false
        
      },

      deleteItem() {
        this.dialogDelete = true;

      },
      updatePermission(p) {
        console.log('updating permission',p,this.editItem)
        let info = {
          permission_name: p.name,
          value: p.value,
          role_id: this.editItem.id
        }
        axios.post("/admin/roles/updateRolePermission",info).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            console.log('got response')
          }
        });
      },


      modifyItem(item) {
        this.editItem = item;
        for(var i=0;i<this.permissions.length;i++)
        {
          let p = this.permissions[i]

          let v = item.permissions.find(o => o.id === p.id);
          if (v)
            this.permissions[i].value = 1
          else
            this.permissions[i].value = 0

          
          this.dialogEdit = true;
        }
      },

      saveAddDialog () {
        this.loadingAdd=true;
        console.log('adding role',this.newrole)
        axios.post("/admin/roles/add",this.newrole).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Add failed');
          
            console.log('add response',response)
          this.loadingAdd = false;
        });
        //this.dialogAdd = false
      },
      
    },
  }
  </script>
  